export enum Align {
  Left = 'left',
  Right = 'right'
}
